import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 235px 0 235px;
  padding: 18px 0;
  justify-content: space-between;
  ${"" /* background-color: #FAFAFA; */}
  aliten-items: center;
  @media (max-width: 1350px) {
    margin: 0 130px 0 130px;
  }

  @media (max-width: 1024px) {
    margin: 0 26px 0 38px;
  }
`;

export const SubHeading = styled.h3`
  margin: 0;
  font-family: NunitoSans-Regular;
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 50px;
  /* identical to box height, or 150% */

  letter-spacing: 0.5px;

  /* grey 900 */

  color: #d67723;
`;

export const Heading = styled.h1`
  font-family: NunitoSans-Regular;
  font-style: normal;
  font-weight: bold;
  font-size: 200px;
  line-height: 250px;
  letter-spacing: 5px;
  margin: 0;
  margin-bottom: 7px;
  /* black */

  color: #000000;
`;

export const ButtonLink = styled.a`
  z-index: 400;
  display: block;
  width: 172px;
  height: 48px;
  padding: 9px 35px;
  border-radius: 8px;
  background-color: #d67723;
  color: white;
  border: 0;
  cursor: pointer;
  text-decoration: none;
  box-sizing: border-box;
  font-family: NunitoSans-SemiBold;
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;
  align-items: center;
  margin-top: 30px;
  letter-spacing: 0.5px;
  &:hover {
    background-color: #c0c0c0;
  }
`;
